import { render, staticRenderFns } from "./InconsistenciasComponent.vue?vue&type=template&id=a5e0c430&scoped=true&"
import script from "./InconsistenciasComponent.vue?vue&type=script&lang=js&"
export * from "./InconsistenciasComponent.vue?vue&type=script&lang=js&"
import style0 from "./InconsistenciasComponent.vue?vue&type=style&index=0&id=a5e0c430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e0c430",
  null
  
)

export default component.exports